import React, { useState } from 'react';
import 'LIBRARY/Components/StockVerification/stockverification.css';

// 
import {
    CssBaseline,
    Container,
    Grid,
    Typography,
    Box,
    Card,
    CardContent, CardMedia, Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
    IconButton,
    CardHeader,
    Divider,
    Menu,
    MenuItem,
    Stack,
    Paper,
    Fade,
    Popper,
    MenuList
} from "@mui/material";
import Add from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import RightAngleIcon from '@mui/icons-material/ChevronRight';
import ClockIcon from "@mui/icons-material/AccessTime"
import { Person } from "@mui/icons-material"
import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"
import { useSnackbar } from 'notistack';
import ScannedResources from "./ScannedResources";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserCheck, faUser } from '@fortawesome/free-solid-svg-icons';

// 
import LibraryApiCall from 'LibraryApiCall';
import config from 'config';
import axios from "axios";
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';

export default function StockVerification(props) {

    const [addStockVerificationModal, setAddStockVerificationModal] = useState(false);
    const [editMode, setEditMode] = useState(false);

    const [loadingStockVerificationList, setLoadingStockVerificationList] = useState(false);
    const [stockVerificationName, setStockVerificationName] = useState("");
    const [stockVerificationNameError, setStockVerificationNameError] = useState(false);

    const [stockVerificationList, setStockVerificationList] = useState([]);
    const [selectedStockVerification, setSelectedStockVerification] = useState("");

    const [warningModal, setWarningModal] = useState(false);

    const [deleteConfirmText, setDeleteConfirmText] = useState("");
    const [deleteConfirmTextError, setDeleteConfirmTextError] = useState(false);

    const [isScannedResources, setIsScannedResources] = useState(false);
    const [selectedStockVerificationId, setSelectedStockVerificationId] = useState("");

    const { enqueueSnackbar } = useSnackbar();

    // Menu Properties 



    const handleClick = (item) => {
        if (selectedStockVerificationId == "") {
            setSelectedStockVerification(item)
            setSelectedStockVerificationId(item.uniqueId)
        } else {
            setSelectedStockVerification({})
            setSelectedStockVerificationId("")
        }

    };



    React.useEffect(() => {
        apiCallToGetStockVerificationList();
    }, [])

    React.useEffect(() => {
        apiCallToGetStockVerificationList();
    }, [selectedStockVerification])


    // Handle Add Stock Verification Modal
    const openAddStockVerificationModal = () => {
        setAddStockVerificationModal(true)
    }

    // Handle Add Stock Verification Modal
    const closeAddStockVerificationModal = () => {
        setAddStockVerificationModal(false)
        setEditMode(false);
    }


    // API CALL TO GET STOCK VERIFICATION LIST
    const apiCallToGetStockVerificationList = async () => {


        let requestData = {
            "iid": config.institute_id,
        }


        let jsonResponse = await LibraryApiCall.makeApiCall('getDashboardStockVerification', requestData, '/api/library/stockVerification.php');
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetStockVerificationList()
            }, 1000);
        }
        else {
            if (jsonResponse.success) {
                if (jsonResponse.APIResult.status != "fail") {

                    Object.keys(jsonResponse.APIResult.data).map((keys) => {
                        jsonResponse.APIResult.data[keys]['uniqueId'] = keys;
                    })

                    setStockVerificationList(Object.values(jsonResponse.APIResult.data));
                    setLoadingStockVerificationList(false)

                } else {
                    setLoadingStockVerificationList(false);
                }
            }
            else {
                setLoadingStockVerificationList(false);
            }
        }
    }

    // API CALL TO ADD STOCK VERIFICATION
    const apiCallToAddStockVerification = async () => {


        if (stockVerificationName == "") {
            setStockVerificationNameError(true);
            return;
        }


        let requestData = {
            "iid": config.institute_id,
            "facultyId": config.faculty_id,
            "stock_verification_name": stockVerificationName
        }


        let jsonResponse = await LibraryApiCall.makeApiCall('addLibraryResourceStockVerification', requestData, '/api/library/stockVerification.php')
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToAddStockVerification()
            }, 1000);
        }
        else {
            if (jsonResponse.success) {
                if (jsonResponse.APIResult.status != "fail") {
                    setAddStockVerificationModal(false);
                    setSelectedStockVerification({});

                    setTimeout(() => {
                        enqueueSnackbar(jsonResponse.APIResult.message, { variant: 'success' });
                        apiCallToGetStockVerificationList()
                    }, 3000)
                } else {

                    enqueueSnackbar(jsonResponse.APIResult.message, { variant: 'error' });

                }
            }
            else {
                enqueueSnackbar(jsonResponse.APIResult.message, { variant: 'warning' });
            }

        }

    }

    // API CALL TO ADD STOCK VERIFICATION
    const apiCallToEditStockVerification = async () => {

        if (stockVerificationName == "") {
            setStockVerificationNameError(false);
            return;
        }


        let requestData = {
            "iid": config.institute_id,
            "facultyId": config.faculty_id,
            "uniqueId": selectedStockVerification.uniqueId,
            "stock_verification_name": stockVerificationName
        }


        let jsonResponse = await LibraryApiCall.makeApiCall('updateLibraryResourceStockVerification', requestData, '/api/library/stockVerification.php')
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToEditStockVerification()
            }, 1000);
        }
        else {
            if (jsonResponse.success) {
                if (jsonResponse.APIResult.status != "fail") {
                    setAddStockVerificationModal(false);
                    setSelectedStockVerification({});
                    setStockVerificationName("");
                    setStockVerificationNameError(false);

                    setTimeout(() => {
                        enqueueSnackbar(jsonResponse.APIResult.message, { variant: 'success' });
                        apiCallToGetStockVerificationList()
                    }, 3000)

                } else {
                    enqueueSnackbar(jsonResponse.APIResult.message, { variant: 'error' });
                }
            }
            else {
                enqueueSnackbar(jsonResponse.APIResult.message, { variant: 'warning' });
            }
        }

    }

    // API CALL TO ADD STOCK VERIFICATION
    const apiCallToRemoveStockVerification = async () => {

        if (deleteConfirmText != "DELETE PERMANENTLY") {
            setDeleteConfirmTextError(true);
            return;
        }


        let requestData = {
            "iid": config.institute_id,
            "uniqueId": selectedStockVerification.uniqueId,
            "facultyId": config.faculty_id
        }


        let jsonResponse = await LibraryApiCall.makeApiCall('deleteLibraryResourceStockVerification', requestData, '/api/library/stockVerification.php')
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToRemoveStockVerification()
            }, 1000);
        }
        else {
            if (jsonResponse.success) {
                if (jsonResponse.APIResult.status != "fail") {
                    // this.setState({
                    //     deleteModal: false,
                    //     selectedStockVerificationId: "",
                    //     deleteConfirmText: "",
                    //     deleteConfirmTextError: false,
                    //     apiResponseMessage: jsonResponse.APIResult.message,
                    //     successModal: true,
                    // })
                    setWarningModal(false);
                    setSelectedStockVerification({});
                    setDeleteConfirmText("");
                    setDeleteConfirmTextError(false);


                    setTimeout(() => {
                        enqueueSnackbar(jsonResponse.APIResult.message, { variant: 'success' });
                        apiCallToGetStockVerificationList()
                    }, 3000)


                } else {
                    enqueueSnackbar(jsonResponse.APIResult.message, { variant: 'error' });
                }
            }
            else {
                enqueueSnackbar(jsonResponse.APIResult.message, { variant: 'warning' });
            }
        }

    }

    // HANDLE EDIT STOCK VERIFICATION NAME
    const handleEdit = (item) => {
        setSelectedStockVerification(item)
        setStockVerificationName(item.stock_verification_name)
        setEditMode(true)
        setAddStockVerificationModal(true)
    }

    // HANDLE DELETE STOCK VERIFCATION NAME
    const handleDelete = (item) => {
        setSelectedStockVerification(item)
        setWarningModal(true);
    }

    if (isScannedResources) {
        return <ScannedResources selectedStockVerification={selectedStockVerification} closeScannedResources={() => {
            setIsScannedResources(false);
            setSelectedStockVerification({})
        }} />
    } else {
        return (
            <>
                <RoutingMenu activeScreen="stockVerification" />
                <div className="libraryStock-container">
                    <CssBaseline />
                    <Grid container sx={{ padding: "4rem 2rem", background: "#F3F3F3" }}>
                        <Box>
                            <Typography variant="h4" color={"#3A3A44"} sx={{"fontSize":18}}>Stock Verification</Typography>
                            <Typography variant="body" sx={{"fontSize":14}}>Verify all your library resource stock.</Typography>
                        </Box>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container columnSpacing={10}>
                                <Grid item lg={5} md={6} sm={12} xs={12}>

                                    <Card sx={{ 'margin': "1rem 0", 'background': 'linear-gradient(to right, rgba(56, 195, 253, 1), rgba(41, 121, 255, 1) 400px)', borderRadius: "8px", p: 1 }} elevation={0}>
                                        <CardContent>
                                            <Box sx={{ display: "flex", "align-items": "center", "justify-content": "space-between" }}>
                                                <Stack spacing={1}>
                                                    <Typography color={"#FFF"} sx={{"fontSize":16}}>What is stock verification ?</Typography>
                                                    <Typography color={"#FFF"} sx={{"fontSize":14}}>An annual or physical stock verification of a library is called a stock verification.In the library, stock verification is performed to determine the number of books on the shelves, the number of books in circulation, and the number of books that are missing from the shelves.</Typography>
                                                </Stack>

                                                <img
                                                    width="80"
                                                    height="80"
                                                    src="./assets/images/box.png"
                                                    alt="green iguana"
                                                    loading="lazy"
                                                />
                                            </Box>
                                        </CardContent>
                                    </Card>

                                    <Card sx={{ 'margin': "1rem 0", 'background': 'linear-gradient(to right, rgba(201, 159, 228, 1), rgba(237, 117, 147, 1) 400px)', borderRadius: "8px", p: 1 }} elevation={0}>
                                        <CardContent>
                                            <Box sx={{ display: "flex", "align-items": "center", "justify-content": "space-between" }}>
                                                <Stack spacing={1}>
                                                    <Typography color={"#FFF"} sx={{"fontSize":16}}>How to do a stock verification ?</Typography>
                                                    <Box>
                                                        <Typography color={"#FFF"} sx={{"fontSize":14}}>1. Start the verification process by clicking on start verification process.</Typography>
                                                        <Typography color={"#FFF"} sx={{"fontSize":14}}>2. Start scanning your resources. You can only use mobile app to scan the resources.</Typography>
                                                        <Typography color={"#FFF"} sx={{"fontSize":14}}>3. Once your scanning completed , please click on “Marked as completed” to get the report of missing and newly found resource.</Typography>
                                                    </Box>
                                                </Stack>

                                                <img
                                                    width="100"
                                                    height="100"
                                                    src="./assets/images/laptop_info.png"
                                                    alt="Laptop Info"
                                                    loading="lazy"
                                                />
                                            </Box>
                                        </CardContent>
                                    </Card>

                                    <Card sx={{ 'margin': "1rem 0", 'background': 'linear-gradient(to right, rgba(169, 162, 255, 1), rgba(74, 106, 205, 1) 400px)', borderRadius: "8px", p: 1 }} elevation={0}>
                                        <CardContent>
                                            <Box sx={{ display: "flex", "align-items": "center", "justify-content": "space-between" }}>
                                                <Stack spacing={1}>
                                                    <Typography color={"#FFF"} sx={{"fontSize":16}}>What are different status of the resources and it’s meaning ?</Typography>
                                                    <Box>
                                                        <Typography color={"#FFF"} sx={{"fontSize":14}}><Typography component={'span'} sx={{ "fontWeight": "bold", "fontSize":14 }}>Total</Typography> is count of all the resources that are present in the library.</Typography>
                                                        <Typography color={"#FFF"} sx={{"fontSize":14}}><Typography component={'span'} sx={{ "fontWeight": "bold", "fontSize":14 }}>Verified</Typography> is count of the resources that are scanned successfully.</Typography>
                                                        <Typography color={"#FFF"} sx={{"fontSize":14}}><Typography component={'span'} sx={{ "fontWeight": "bold", "fontSize":14 }}>Newly found</Typography> is the count of the resources that you have newly found.</Typography>
                                                        <Typography color={"#FFF"} sx={{"fontSize":14}}><Typography component={'span'} sx={{ "fontWeight": "bold", "fontSize":14 }}>Issued</Typography> is count of the resources that are issued to some user and are not yet scanned.</Typography>
                                                        <Typography color={"#FFF"} sx={{"fontSize":14}}><Typography component={'span'} sx={{ "fontWeight": "bold", "fontSize":14 }}>Yet to Scan / Missing</Typography> is the count of the resources that are yet to be scanned or can also be missing.</Typography>
                                                    </Box>
                                                </Stack>


                                                <img
                                                    width="70"
                                                    height="80"

                                                    src="./assets/images/question_info.png"
                                                    alt="Question Info"
                                                    loading="lazy"
                                                />
                                            </Box>
                                        </CardContent>
                                    </Card>

                                </Grid>

                                <Grid item lg={7} md={6} sm={12} xs={12}>
                                    {
                                        stockVerificationList.map((item, index) => {

                                            return (
                                                <Card sx={{ 'margin': '1rem 0', pr: 1, pl: 2 }} elevation={0}>
                                                    <CardHeader
                                                        action={
                                                            <IconButton aria-label="settings" onClick={() => handleClick(item)}>
                                                                <MoreVertIcon />
                                                            </IconButton>
                                                        }
                                                        titleTypographyProps={{"fontSize":16}}
                                                        title={item.stock_verification_name}
                                                    />
                                                    {
                                                        selectedStockVerificationId == item.uniqueId &&
                                                        <MenuList sx={{ "position": "absolute", "z-index": 100, "right": 10, background: "#FFF" }}>
                                                            <MenuItem onClick={() => { handleEdit(item) }}>Edit</MenuItem>
                                                            <MenuItem onClick={() => { handleDelete(item) }}>Delete</MenuItem>
                                                        </MenuList>

                                                    }

                                                    <CardContent>

                                                        <Grid container direction="row" justifyContent="space-between" spacing={4} rowSpacing={4}>
                                                            <Grid item lg={2} md={2} sm={3} xs={4}>
                                                                <Box style={{ "display": "flex", "flex-direction": "column", "justify-content": "space-between" }}>
                                                                    <Typography variant="h5" sx={{"fontSize":16}} color="primary" textAlign={"center"}>{item.resourcesCount.totalResource}</Typography >
                                                                    <Typography variant="body2" sx={{"fontSize":14}} textAlign={"center"}>Total</Typography >
                                                                </Box>
                                                            </Grid>
                                                            <Divider orientation="vertical" flexItem sx={{ margin: "0 0.5rem", "border-style": "dashed" }} />
                                                            <Grid item lg={2} md={2} sm={3} xs={4}>
                                                                <Box style={{ "display": "flex", "flex-direction": "column", "justify-content": "space-between" }}>
                                                                    <Typography variant="h5" sx={{ color: "#5DC188", fontSize:16 }} textAlign={"center"}>{item.resourcesCount.totalVerified}</Typography >
                                                                    <Typography variant="body2" sx={{"fontSize":14}} textAlign={"center"}>Verified</Typography >
                                                                </Box>
                                                            </Grid>
                                                            <Divider orientation="vertical" flexItem sx={{ margin: "0 0.5rem", "border-style": "dashed" }} />
                                                            <Grid item lg={2} md={2} sm={3} xs={4}>
                                                            <Box style={{ "display": "flex", "flex-direction": "column", "justify-content": "space-between" }}>
                                                                <Typography variant="h5" sx={{ color: "#BA6AE1", fontSize:16 }} textAlign={"center"}>{item.resourcesCount.totalNewlyFound}</Typography >
                                                                <Typography variant="body2" sx={{"fontSize":14}} textAlign={"center"}>Newly Found</Typography >
                                                            </Box>
                                                            </Grid>
                                                            <Divider orientation="vertical" flexItem sx={{ margin: "0 0.5rem", "border-style": "dashed" }} />
                                                            <Grid item lg={2} md={2} sm={3} xs={4}>
                                                            <Box style={{ "display": "flex", "flex-direction": "column", "justify-content": "space-between" }}>
                                                                <Typography variant="h5" sx={{ color: "#5ECEF3", fontSize:16 }} textAlign={"center"}>{item.resourcesCount.totalIssued}</Typography >
                                                                <Typography variant="body2" sx={{"fontSize":14}} textAlign={"center"}>Issued</Typography >
                                                            </Box>
                                                            </Grid>
                                                            <Divider orientation="vertical" flexItem sx={{ margin: "0 0.5rem", "border-style": "dashed" }} />
                                                        <Grid item lg={2} md={2} sm={3} xs={4}>
                                                            <Box style={{ "display": "flex", "flex-direction": "column", "justify-content": "space-between" }}>
                                                                <Typography variant="h5" sx={{ color: "#797986", fontSize:16 }} textAlign={"center"}>{item.resourcesCount.totalMissing}</Typography >
                                                                <Typography variant="body2" sx={{"fontSize":14}} textAlign={"center"}>Yet to Scan / Missing</Typography >
                                                            </Box>
                                                            </Grid>
                                                        </Grid>

                                                        <Grid container direction="row" justifyContent={"space-between"} spacing={2} mt={4}>
                                                            <Stack direction={{md:"row", sm:"column", xs:"column"}} spacing={2} rowSpacing={4}>
                                                                <Stack spacing={1} justifyContent={{xs:"center"}}>

                                                                    <FontAwesomeIcon icon={faUser} color={"#2F80ED"} size={30} />
                                                                    <Typography variant="body2" sx={{"fontSize":14}}>Started by {item.start_by_name}</Typography >
                                                                    <div className="d-flex">
                                                                        <ClockIcon sx={{ color: "#48B9DE" }} />
                                                                        <Typography sx={{ color: "#48B9DE", fontSize:14 }}>{item.start_datetime}</Typography>
                                                                    </div>
                                                                </Stack>


                                                                {
                                                                    item.last_verified_by_name != "" &&
                                                                    <Stack spacing={1} justifyContent={{xs:"center"}}>
                                                                        <FontAwesomeIcon icon={faUserCheck} color={"#2F80ED"} size={30} textAlign={{md:"center", xs:"center"}} />
                                                                        <Typography variant="body2" sx={{"fontSize":14}} textAlign={{md:"center", xs:"center"}}>Last Verified by {item.last_verified_by_name}</Typography >
                                                                        <div className="d-flex">
                                                                            <ClockIcon sx={{ color: "#48B9DE" }} />
                                                                            <Typography textAlign={{md:"center", xs:"center"}} sx={{ color: "#48B9DE", fontSize:14 }}>{item.end_datetime}</Typography>
                                                                        </div>
                                                                    </Stack>
                                                                }

                                                            </Stack>
                                                            <Stack justifyContent={'flex-end'}>
                                                                <Typography variant="body" sx={{"fontSize":14}}><Typography sx={{"fontSize":14}} component="span" variant="h6" color={"#2979FF"} onClick={() => {
                                                                    setIsScannedResources(true);
                                                                    setSelectedStockVerification(item)
                                                                }}>{item.resourcesCount.totalScanned}</Typography> Scanned Resources</Typography >
                                                                <Button variant={'contained'} disableElevation sx={{ 'textTransform': "capitalize", fontSize:14 }} endIcon={<RightAngleIcon />} color={item.stock_verification_status == "Completed" ?"success":"primary"} onClick={() => {
                                                                    setIsScannedResources(true);
                                                                    setSelectedStockVerification(item)
                                                                }}>{item.stock_verification_status == "Completed" ? "Completed" : "View Progress"}</Button>
                                                            </Stack>
                                                        </Grid>


                                                    </CardContent>
                                                </Card>
                                            )
                                        })
                                    }

                                    {
                                        stockVerificationList.length < 3 &&
                                        <Card sx={{ 'display': "flex", 'justify-content': 'center', 'align-items': 'center', 'padding': '3rem' }} elevation={0}>
                                            <CardContent>
                                                <Button sx={{"fontSize":14}} startIcon={<Add />} onClick={openAddStockVerificationModal}>Start Stock Verification</Button>
                                            </CardContent>
                                        </Card>

                                    }

                                    <Card sx={{ 'display': "flex", 'justify-content': 'center', 'align-items': 'center', background: "#FFEFDE", mt: 2 }} elevation={0}>
                                        <CardContent>
                                            <Typography sx={{"fontSize":14}}>
                                                You can only do “3 Stock Verification” at a time. If you need to have one more stock verificatiom, please first delete the previously added stock verification.
                                            </Typography>
                                        </CardContent>
                                    </Card>

                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Dialog open={addStockVerificationModal} onClose={closeAddStockVerificationModal}>
                        <Box sx={{ display: "flex", 'justify-content': "space-between", " align-items": "center", background: "#0465AC" }}>
                            <DialogTitle color={"#FFF"} sx={{fontSize:16}}>
                                {editMode ? "Update" : "Add New Verification"}
                            </DialogTitle>
                            <IconButton onClick={closeAddStockVerificationModal}>
                                <CloseIcon color={"#FFF"} />
                            </IconButton>
                        </Box>
                        <DialogContent>

                            <TextField
                                autoFocus
                                margin="dense"
                                id="name"
                                value={stockVerificationName}
                                label="Enter Name"
                                type="text"
                                onChange={(e) => {
                                    setStockVerificationName(e.target.value)
                                }}
                                error={stockVerificationNameError}
                                fullWidth
                            />
                            {
                                stockVerificationNameError &&
                                <Typography>Please enter stock verification name.</Typography>
                            }
                            <DialogContentText sx={{fontSize:14}}>
                                e.g 2020-21 Stock Verificaion, 2021-22 Stock Verification
                            </DialogContentText>
                        </DialogContent>

                        <DialogActions>
                            {
                                editMode ?
                                    <Button variant="contained" sx={{fontSize:14}} onClick={() => apiCallToEditStockVerification()}>Update</Button>
                                    :
                                    <Button variant="contained" sx={{fontSize:14}} onClick={() => apiCallToAddStockVerification()}>Start</Button>
                            }

                            <Button variant="outlined" sx={{fontSize:14}} onClick={closeAddStockVerificationModal}>Cancel</Button>
                        </DialogActions>
                    </Dialog>


                    {/* Warning Modal */}
                    <Dialog open={warningModal} onClose={() => setWarningModal(false)}>
                        <Box sx={{ display: "flex", 'justify-content': "space-between", " align-items": "center", background: "#B30A16" }}>
                            <DialogTitle color={"#FFF"}>Are you sure ?</DialogTitle>
                            <IconButton onClick={() => setWarningModal(false)}>
                                <CloseIcon color="#FFF" />
                            </IconButton>
                        </Box>
                        <DialogContent>
                            <Typography sx={{fontSize:14}}>Note</Typography>
                            <Typography sx={{fontSize:14}}>
                                Once deleted cannot be retrieved.
                                All data associated with this entry will be deleted permanently.
                            </Typography>
                            <Typography sx={{fontSize:14}}>If you delete stock verification, all data will be deleted permanetly.</Typography>
                            <Typography sx={{fontSize:14}}>If you want to delete the entry, type “DELETE PERMANETLY” in block/capital letters in below input text for confirmaion.</Typography>

                            <TextField
                                margin="normal"
                                id="name"
                                label="Please type DELETE PERMANENTLY here"
                                placeholder="Please type DELETE PERMANENTLY here"
                                type="text"
                                value={deleteConfirmText}
                                onChange={(e) => setDeleteConfirmText(e.target.value)}
                                fullWidth
                            />
                            {
                                deleteConfirmTextError &&
                                <Typography sx={{fontSize:14}}>Please enter.</Typography>
                            }

                        </DialogContent>

                        <DialogActions>
                            <Button variant="contained" sx={{fontSize:14}} color={'error'} disableElevation onClick={() => setWarningModal(false)}>No</Button>
                            <Button variant="outlined" sx={{fontSize:14}} onClick={() => apiCallToRemoveStockVerification()}>Yes</Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </>
        )
    }
}


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};